import React from 'react';

export const MainContent = ({ children }: { children: React.ReactNode }) => {
    return <div id="maincontent">{children}</div>;
};
